export const getAllAgents = () => ({
  type: 'GET_ALL_AGENTS',
});

export const getAllTemplateAgents = () => ({
  type: 'GET_ALL_TEMPLATE_AGENTS',
});

export const setAllAgents = (payload) => ({
  payload,
  type: 'SET_ALL_AGENTS',
});

export const getSingleAgent = (payload) => ({
  payload,
  type: 'GET_SINGLE_AGENT',
});

export const setSingleAgent = (payload) => ({
  payload,
  type: 'SET_SINGLE_AGENT',
});

export const setNewAgentModal = (payload) => ({
  payload,
  type: 'SET_NEW_AGENT_MODAL',
});

export const createAgent = ({ data, successCallback, failCallback }) => ({
  type: 'CREATE_AGENT',
  payload: { data, successCallback, failCallback },
});

export const updateAgent = (id, data, successCallback, failCallback) => ({
  type: 'UPDATE_AGENT',
  payload: { id, data, successCallback, failCallback }
});

export const deleteAgent = (payload) => ({
  payload,
  type: 'DELETE_AGENT',
});

export const cloneAgent = (payload) => ({
  payload,
  type: 'CLONE_AGENT',
});

export const addAgent = (payload) => ({
  payload,
  type: 'ADD_AGENT',
});

export const getConnectionDetails = (payload) => ({
  payload,
  type: 'GET_CONNECTION_DETAILS',
});

export const getVoiceAgentStatus = (payload) => ({
  payload,
  type: 'GET_VOICE_AGENT_STATUS',
});

export const setConnectionDetails = (payload) => ({
  payload,
  type: 'SET_CONNECTION_DETAILS',
});

export const updateAgentVoice = (payload) => ({
  payload,
  type: 'UPDATE_AGENT_VOICE',
});

export const getPromptVersions = (payload) => ({
  payload,
  type: 'GET_PROMPT_VERSIONS',
});

export const getPromptVersionDetail = (payload) => ({
  payload,
  type: 'GET_PROMPT_VERSION_DETAIL',
});

export const restorePromptVersion = (payload) => ({
  payload,
  type: 'RESTORE_PROMPT_VERSION',
});

export const proposePromptUpdate = (payload) => ({
  payload,
  type: 'PROPOSE_PROMPT_UPDATE',
});